var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticClass:"toolbar pagination",attrs:{"span":24}},[_c('el-pagination',{staticStyle:{"float":"right"},attrs:{"background":"","layout":"total, prev, pager, next, jumper","page-size":10,"total":_vm.childMsg.total,"current-page":_vm.childMsg.pageNo},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }